<template>
  <router-view />
</template>

<script>
import { ms, db, getToken, onMessage, auth } from "./firebase";
import notificacionesObserver from "./services/NotificacionesObserver";

export default {
  name: "App",
  data() {
    return {
      user: {},
      uiduser: null,
      setInterval: null,
      mensaje: "",
    };
  },
  async created() {
    this.$store.commit("authData");
    await this.GenerarTokenPush();
    this.message();
    await this.PruebaApiFirebaseNew();
    notificacionesObserver.iniciar();
  },
  methods: {
    setIntervalUbicacion() {
      this.setInterval = setInterval(() => {
        this.ActualizarUbicaciones();
      }, 4000);
    },
    async GenerarTokenPush() {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          auth.onAuthStateChanged((user) => {
            if (user) {
              getToken(ms, {
                vapidKey: process.env.VUE_APP_VAPIDKEY,
                // vapidKey: process.env.VUE_APP_VAPIDKEY_SANDBOX,
              })
                .then((currentToken) => {
                  if (currentToken) {
                    //console.log(currentToken);
                    localStorage.setItem("tokenPush", currentToken);
                    db.collection("usuarios")
                      .doc(this.uiduser)
                      .update({
                        tokenPush: currentToken,
                      })
                      .then(() => {
                        this.$toast.update(this.toastId, {
                          content: "Token Actualizado!",
                          options: {
                            type: "success",
                            position: "top-right",
                            timeout: 2413,
                            closeOnClick: false,
                            pauseOnFocusLoss: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 0.6,
                            showCloseButtonOnHover: false,
                            hideProgressBar: true,
                            closeButton: "button",
                            icon: "fas fa-rocket",
                            rtl: false,
                          },
                        });
                      })
                      .catch((error) => {
                        console.log(error);
                      });
                  } else {
                    // Show permission request UI
                    console.log(
                      "No registration token available. Request permission to generate one."
                    );
                    // ...
                  }
                })
                .catch((err) => {
                  console.log(
                    "An error occurred while retrieving token. ",
                    err
                  );
                });
            }
          });
        }
      });
    },
    async PruebaApiFirebaseNew() {
      //
    },
    TokenPush(collection) {
      if (!localStorage.getItem("tokenPush")) {
        return;
      }
      db.collection(collection)
        .doc(this.uiduser)
        .update({
          tokenPush: localStorage.getItem("tokenPush"),
        })
        .then(() => {
          // console.log(":::Actualizo token push::::");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    ActualizarUbicaciones() {
      try {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.latitud = position.coords.latitude;
            this.longitud = position.coords.longitude;
            db.collection("usuarios")
              .doc(this.uiduser)
              .update({
                lat: position.coords.latitude,
                long: position.coords.longitude,
              })
              .then(() => {
                // console.log(
                //   position.coords.latitude + "::" + position.coords.longitude
                // );
                this.$store.dispatch("actionGps", true);
                // console.log(":::Actualizo ubicacion::::");
              })
              .catch((error) => {
                console.log(error);
              });
          },
          (err) => {
            console.log(err);
            this.$store.dispatch("actionGps", false);
            clearInterval(this.setInterval);
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
    async message() {
      onMessage(ms, (payload) => {
        console.log(payload);
        this.mensaje = payload.notification.body;
        this.addInfoNotification();
      });
    },
    addInfoNotification() {
      console.log(this.mensaje);
      this.$toast.info(this.mensaje, {
        position: "bottom-right",
        timeout: false,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: "button",
        icon: false,
      });
    },
  },
  mounted() {},
  beforeDestroy() {
    // Limpiar el observer cuando el componente se destruya
    notificacionesObserver.detener();
    if (this.setInterval) {
      clearInterval(this.setInterval);
    }
  },
  watch: {
    "$store.state.logueado": function () {
      if (!auth) {
        clearInterval(this.setInterval);
        return;
      }

      if (this.$store.state?.logueado?.id) {
        this.uiduser = this.$store.state?.logueado?.id;
        this.TokenPush("usuarios"); // ACTUALIZAMOS EL TOKEN PUSH
        this.setIntervalUbicacion();
      } else {
        clearInterval(this.setInterval);
      }
    },
    "$store.state.cliente": function () {
      if (this.$store.state?.cliente) {
        this.uiduser = this.$store.state?.cliente;
        this.TokenPush("clientes"); // ACTUALIZAMOS EL TOKEN PUSH
      }
    },
  },
};
</script>

<style src="./styles/app.scss" lang="scss" />
